import { observer } from "mobx-react-lite";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { useStore } from "@/store";

export const MobileMenuButton = observer(function MobileMenuButton() {
  const { view } = useStore();

  const handleMenuButtonClick = () => {
    view.isMobileDownloadVisible = false;
    view.isMobileMenuVisible = !view.isMobileMenuVisible;
  };

  return (
    <Sidebar.Button
      onClick={handleMenuButtonClick}
      icon={
        view.isMobileMenuVisible ? (
          <div className="rounded-8 flex w-8 h-8 -m-1 bg-blue-100 dark:bg-blue-900">
            <Icon name="More" className="m-auto w-7 h-7 [&>path]:fill-blue-500" />
          </div>
        ) : (
          <Icon name="More" className="m-auto w-7 h-7" />
        )
      }
    />
  );
});
